
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"12","viewBox":"0 0 37 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.2031 0.212102L9.39175 11.8185H6.25269L3.885 2.55606C3.74125 1.98555 3.61626 1.77655 3.17909 1.53619C2.46572 1.14469 1.28704 0.777577 0.25 0.549607L0.320438 0.212102H5.37337C6.01745 0.212102 6.59646 0.645594 6.74269 1.3955L7.99315 8.11153L11.0836 0.212102H14.2031ZM26.5027 8.02909C26.5153 4.96581 22.3132 4.79706 22.3421 3.42865C22.3511 3.01219 22.7433 2.56941 23.6018 2.45639C24.0273 2.40008 25.1996 2.35712 26.5293 2.97581L27.0509 0.514579C26.3364 0.252355 25.4171 0 24.2732 0C21.338 0 19.2723 1.5776 19.2549 3.8366C19.236 5.50748 20.7293 6.43988 21.8544 6.9951C23.0118 7.56367 23.4002 7.92904 23.3958 8.43762C23.3876 9.21617 22.4726 9.55986 21.6176 9.57341C20.1251 9.59663 19.2589 9.16508 18.5685 8.84054L18.0303 11.3832C18.7241 11.7051 20.0048 11.9859 21.3326 12C24.4524 12 26.4931 10.4419 26.5027 8.02909ZM34.2535 11.8187H37L34.6026 0.212102H32.0677C31.4976 0.212102 31.0168 0.547671 30.804 1.0636L26.3479 11.8185H29.4661L30.0853 10.0847H33.8952L34.2537 11.8185L34.2535 11.8187ZM30.9401 7.7061L32.5031 3.34834L33.4027 7.7061H30.9403H30.9401ZM18.4462 0.212102L15.9907 11.8185H13.0212L15.4777 0.212102H18.4462Z","fill":"#1434CB"}})])
          )
        }
      }
    